import { Field, Input, Label, Textarea } from '@headlessui/react';
import Favico from './Favico';
import SocialImage from './SocialImage';
import usePlayground from '@/modules/playground/hooks/usePlayground.hook';
import { PlaygroundAction, PlaygroundActionType } from '@/modules/playground/types/playground-action.type';
import Button from '@/core/design-system/Button';
import { useState } from 'react';

const SiteSettings = () => {
  const { state, dispatchWithDebounce, handleSubmit, isSubmitting } = usePlayground();
  const [showPageInSearchEngines, setShowPageInSearchEngines] = useState<boolean>(
    state.payload.site_settings?.show_page_in_search_engines ?? true,
  );

  const handleInputChange =
    (actionType: PlaygroundActionType) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { value, name } = e.target;
      const action = {
        type: actionType,
        payload: {
          site_settings: {
            [name]: value,
          },
        },
      };

      dispatchWithDebounce(action as PlaygroundAction);
    };

  const showPageInSearchEnginesHandler = () => {
    setShowPageInSearchEngines(!showPageInSearchEngines);

    const action = {
      type: PlaygroundActionType.SET_PAYLOAD,
      payload: {
        site_settings: {
          show_page_in_search_engines: !showPageInSearchEngines,
        },
      },
    };

    dispatchWithDebounce(action as PlaygroundAction);
  };

  return (
    <>
      <Field>
        <Label className="text-md text-lighter">Site Title</Label>
        <Input
          defaultValue={state.payload.site_settings?.title}
          name="title"
          className="block w-full mt-2 rounded-lg border border-solid border-secondary py-2 px-2 text-white bg-main focus:outline-none focus:border-primary transition-colors duration-200 ease-in-out"
          onChange={handleInputChange(PlaygroundActionType.SET_PAYLOAD)}
          onKeyDown={(e) => e.stopPropagation()}
        />
      </Field>

      <Field className="mt-4">
        <Label className="text-md text-lighter">Site Description</Label>
        <Textarea
          defaultValue={state.payload.site_settings?.description}
          name="description"
          className="block w-full mt-2 rounded-lg border border-solid border-secondary py-2 px-2 text-white bg-main focus:outline-none focus:border-primary transition-colors duration-200 ease-in-out"
          rows={3}
          onChange={handleInputChange(PlaygroundActionType.SET_PAYLOAD)}
          onKeyDown={(e) => e.stopPropagation()}
        />
      </Field>

      <div className="flex items-center mt-4">
        <label className="flex items-center cursor-pointer">
          <input
            type="checkbox"
            className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
            checked={showPageInSearchEngines}
            onChange={showPageInSearchEnginesHandler}
          />
          <p className="text-white text-sm ml-2">Show page in search engines</p>
        </label>
      </div>

      <div className="w-full h-[1px] bg-secondary my-6" />

      <p className="text-md text-lighter">Favicon</p>
      <span className="text-[10px] text-light">
        Upload a 32 x 32 pixel ICO, PNG, GIF, or JPG to display in browser tabs.
      </span>
      <Favico />

      <div className="w-full h-[1px] bg-secondary my-6" />

      <p className="text-md text-lighter">Social Image</p>
      <span className="text-[10px] text-light">1200 x 630 pixels </span>
      <SocialImage />

      <Button
        type="button"
        className="w-20 mt-8"
        disabled={state.actions.length === 0 || isSubmitting}
        onClick={handleSubmit}
      >
        Save
      </Button>
    </>
  );
};

export default SiteSettings;
